<template>
  <v-footer padless outlined>
    <v-row
      justify="center"
      no-gutters
    >
      <v-col
        class="bold--text subtitle-2"
        cols="12"
      >
        &copy;Copyright {{ new Date().getFullYear() }} <a class="navomi-link" target="_blank" href="https://navomi.com/" rel="noopener">NAVOMI, Inc.</a>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  .navomi-link {
    color: rgba(0, 0, 0, 0.87) !important;
    text-decoration: none;
  }
</style>